import React from 'react';
import '../App.css';

const TeamCard = (props) => {
    return(<div>
        <div className="team-card-wrapper">
            <a href={props.linkedinLink}>
                <img src={props.propic} className="team-card-pic"></img>
            </a>
            <div className="team-card-name">
                {props.name}
            </div>
            <div className="team-card-title">
                {props.title}
            </div>
            {/* <div className="team-card-major">
                {props.major}
            </div> */}
            <div className="team-card-bio">
                {props.bio}
            </div>
        </div>
    </div>)
}

export default TeamCard;